import AntDraggableModal from '../../utils/extend/AntDraggableModal'
import Logger, { loggerType } from './logger/Logger';

const WebUniversalLogger = (props: any) => {
    const { data, closeModal } = props;
    const { logger, queryType, queryId } = data;
    let currentLogger: loggerType = {
        id: 'systemLogger',
        name: '系统日志'
    }
    if (logger) {
        switch (logger.id) {
            case 'opLogger':
                currentLogger = {
                    id: 'opLogger',
                    name: '操作日志'
                }
                break;
            case 'loginLogger':
                currentLogger = {
                    id: 'loginLogger',
                    name: '登录日志'
                }
                break;
            case 'menuOpLogger':
                currentLogger = {
                    id: 'menuOpLogger',
                    name: '菜谱操作日志'
                }
                break;
            case 'reserveMenuOpLogger':
                currentLogger = {
                    id: 'reserveMenuOpLogger',
                    name: '菜单操作日志'
                }
                break;
            case 'salePeriodOpLogger':
                currentLogger = {
                    id: 'salePeriodOpLogger',
                    name: '时段操作日志'
                }
                break;
            case 'ingredientOpLogger':
                currentLogger = {
                    id: 'ingredientOpLogger',
                    name: '主配料操作日志'
                }
                break;
            case 'warehouseLogger':
                currentLogger = {
                    id: 'warehouseLogger',
                    name: '仓库日志'
                }
                break;
        }
    }

    const dataEx = { ...data, logger: currentLogger };

    return (
        <>
            <AntDraggableModal
                title={`${currentLogger.name ? currentLogger.name : ''}【${queryType}${queryId ? '-' + queryId : ''}】日志`}
                open={true}
                okText='关闭'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={1080}
            >
                <Logger data={dataEx} />
            </AntDraggableModal>
        </>
    )
}

export default WebUniversalLogger;